import ParagraphPrimary from 'components/ui/Paragraphs/ParagraphPrimary';
import * as React from 'react';
import { connect } from 'react-redux';
import { fetchConfig } from 'store/config/configActions';
import { translate } from 'utils/translateUtil';

import ErrorLayout from '../error/ErrorLayout';

const AuthenticationInfo = (props: any) => {
    React.useEffect(props.fetchConfig, []);
    return (
        <ErrorLayout
            headline={translate('globals.authenticationInfo.title')}
            description={
                <>
                    <ParagraphPrimary>
                        {translate('globals.authenticationInfo.paragraphs.0')}
                        <br /><br />
                        {translate('globals.authenticationInfo.paragraphs.1')}
                        <br />
                        {translate('globals.authenticationInfo.paragraphs.2')}
                        <br /><br />
                        {translate('globals.authenticationInfo.paragraphs.3')}
                        <br />
                        {translate('globals.authenticationInfo.paragraphs.4')}
                    </ParagraphPrimary>
                </>
            }
        />
    );
};
const mapDispatchToProps = {
    fetchConfig
}
const mapStateToProps = (state: any) => (
    { config: state.config }
)
export default connect(mapStateToProps, mapDispatchToProps)(AuthenticationInfo as any);
